/** Meta pixel of Kampsport Kids Ready Norge (Norwegian copy): "pixel martial arts no" 1594764189054647.
 *  NEVER the English (1694960845480040), German (1457228929623029), French (1660443269144667), Italian (975090402319706),
 *  Dutch (2546249665877855), Polish (1426143019050867) or Swedish (1079711778166299) Martial pixel.
 *  PageView on load, ViewContent when the offer section is seen, InitiateCheckout ONLY on the offer button. */
export const META_PIXEL_ID: string = '1594764189054647';
